export default __webpack_public_path__ + "static/media/Slide1.71edf78f.PNG";